import { createComponent } from '@carvana/merch-components';

export const StickyWrapper = createComponent('div', {
  className: 'top-0 z-[1] flex w-full flex-col px-16 pb-16 m:px-0'
});

export const Header = createComponent('div', {
  className: 'grid w-full grid-cols-[1fr_auto] gap-x-12 px-0 pb-16'
});

export const Input = createComponent('input', {
  className: 'text-ellipsis border-0 bg-grey-1 tl-body-s m:tl-body-m',
  'data-qa': 'search-bar-input'
});

export const SearchToolsContainer = createComponent('div', {
  className:
    'grid grid-cols-[1fr_auto] items-center gap-x-16 bg-grey-1 px-16 pt-16 m:bg-white m:p-0'
});

export const SortSaveSearch = createComponent('div', {
  className:
    'space-between flex flex-row gap-x-16 tl-header-xs m:gap-x-24 m:tl-header-s'
});

export const IconWithTextWrapper = createComponent('div', {
  className: 'grid grid-cols-[auto_1fr] items-center gap-x-8'
});

export const Bar = createComponent('div', {
  className: 'h-[20px] border-0 border-l-2 border-solid border-grey-2'
});

export const SearchInputWrapper = createComponent('div', {
  className: 'relative flex h-[47px] w-full flex-row justify-between m:h-[57px]'
});
